/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Zendesk extends CacheEnabledApiClient {
  constructor() {
    super('zendesk', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'zendesk';
  }

  async getUsers(subdomain, email, api_token) {
    try {
      const url = `${this.url}/users?subdomain=${subdomain}&email=${email}&api_token=${api_token}`;

      const response = await axios.get(url);
      return response.data ?? [];
    } catch (error) {
      console.error('error', error);
      return null;
    }
  }

  async getGroups(subdomain, email, api_token) {
    try {
      const url = `${this.url}/groups?subdomain=${subdomain}&email=${email}&api_token=${api_token}`;

      const response = await axios.get(url);
      return response.data ?? [];
    } catch (error) {
      console.error('error', error);
      return null;
    }
  }

  async getTags(subdomain, email, api_token) {
    try {
      const url = `${this.url}/tags?subdomain=${subdomain}&email=${email}&api_token=${api_token}`;

      const response = await axios.get(url);
      return response.data ?? [];
    } catch (error) {
      console.error('error', error);
      return null;
    }
  }

  async fetchConversations(identifier, { beginDate, endDate, force } = {}) {
    const url = `${this.url}/fetch_conversations`;
    const response = await axios.post(url, {
      identifier,
      begin_date: beginDate,
      end_date: endDate,
      force,
    });
    return response.data;
  }
}

export default new Zendesk();
